(function () {
  if (window.__sizeGuideWizardInit) return;
  window.__sizeGuideWizardInit = true;

  const TRIGGER_SELECTOR = '[data-size-guide-wizard-trigger]';
  const ROW_SELECTOR = '[data-size-guide-wizard-row]';
  const WIZARD_ROOT_SELECTOR = '[class*="PwzrGrid"]';
  const TITLE_SELECTORS = [
    '.rio-product-option-title',
    '[class*="rio-product-option-title"]',
    '[class*="product-option-title"]',
  ];
  const SIZE_KEYWORDS = ['size', 'tamanho', 'length', 'comprimento'];

  // The wizard nests each option in several unwrapped flex rows, so the row has to be
  // hoisted out of them to end up on its own line below the values.
  const MAX_HOIST_DEPTH = 4;

  function readConfigs() {
    const seenModalIds = new Set();

    return [...document.querySelectorAll('[data-size-guide-wizard-config]')]
      .map((element) => {
        try {
          const config = JSON.parse(element.textContent.trim());
          if (config.enabled === false) return null;

          const modalId = element.dataset.modalId || config.modalId || '';
          if (modalId && seenModalIds.has(modalId)) return null;
          if (modalId) seenModalIds.add(modalId);

          return {
            linkText: config.linkText || 'View Size Guide',
            optionName: config.optionName || 'Size',
            modalId,
          };
        } catch {
          return null;
        }
      })
      .filter(Boolean);
  }

  function isSizeOption(label, configuredName) {
    const normalized = (label || '').trim().toLowerCase();
    if (!normalized) return false;

    const configured = (configuredName || 'size').trim().toLowerCase();
    if (normalized === configured || normalized.includes(configured)) return true;

    return SIZE_KEYWORDS.some((keyword) => normalized.includes(keyword));
  }

  function hasWizardDOM() {
    return Boolean(document.querySelector(WIZARD_ROOT_SELECTOR));
  }

  function isLabelCandidate(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (element.closest(ROW_SELECTOR)) return false;
    if (element.matches('button, input, select, option, svg, path, img')) return false;

    const text = (element.textContent || '').trim();
    if (!text || text.length > 32) return false;

    const childElements = [...element.children].filter(
      (child) => child.tagName !== 'BR' && child.tagName !== 'SPAN'
    );
    if (childElements.length > 0) return false;

    return true;
  }

  function findWizardTitleElements(configuredName) {
    const titles = new Set();

    TITLE_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        if (element instanceof HTMLElement && isSizeOption(element.textContent, configuredName)) {
          titles.add(element);
        }
      });
    });

    document.querySelectorAll('[class*="PwzrGrid-item"]').forEach((item) => {
      item.querySelectorAll('div, span, label, p, h3, h4, strong').forEach((element) => {
        if (!isLabelCandidate(element)) return;
        if (!isSizeOption(element.textContent, configuredName)) return;
        titles.add(element);
      });
    });

    return outermost([...titles]);
  }

  function outermost(elements) {
    return elements.filter(
      (element) => !elements.some((other) => other !== element && other.contains(element))
    );
  }

  function markWizardActive() {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      picker.classList.add('variant-picker--wizard-active');
    });
  }

  function getOptionBlock(element) {
    return element.closest('[class*="PwzrGrid-item"]') || element.closest(WIZARD_ROOT_SELECTOR);
  }

  /**
   * Resolves the elements that hold the option values, so the trigger can be placed after them.
   */
  function findOptionAnchors(config) {
    const byDataOption = [...document.querySelectorAll('[data-option]')].filter((element) =>
      isSizeOption(element.getAttribute('data-option'), config.optionName)
    );
    if (byDataOption.length) return outermost(byDataOption);

    const byAriaLabel = [...document.querySelectorAll(`${WIZARD_ROOT_SELECTOR}[aria-label]`)].filter(
      (element) => isSizeOption(element.getAttribute('aria-label'), config.optionName)
    );
    if (byAriaLabel.length) return outermost(byAriaLabel);

    const byTitle = findWizardTitleElements(config.optionName)
      .map(getOptionBlock)
      .filter(Boolean);

    return outermost(byTitle);
  }

  function isNowrapRow(element) {
    const styles = getComputedStyle(element);
    if (!styles.display.includes('flex')) return false;
    if (!styles.flexDirection.startsWith('row')) return false;

    return styles.flexWrap === 'nowrap';
  }

  function resolveRowSibling(anchor) {
    let target = anchor;

    for (let depth = 0; depth < MAX_HOIST_DEPTH; depth += 1) {
      const parent = target.parentElement;
      if (!parent || !parent.closest(WIZARD_ROOT_SELECTOR)) break;
      if (!isNowrapRow(parent)) break;
      target = parent;
    }

    return target;
  }

  function createRow() {
    const row = document.createElement('div');
    row.className = 'size-guide-wizard-row';
    row.dataset.sizeGuideWizardRow = 'true';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'variant-option__size-guide-trigger';
    trigger.dataset.sizeGuideWizardTrigger = 'true';

    row.appendChild(trigger);

    return row;
  }

  function applyConfig(row, config) {
    row.dataset.modalId = config.modalId || '';

    const trigger = row.querySelector(TRIGGER_SELECTOR);
    if (!trigger) return;

    if (trigger.textContent !== config.linkText) {
      trigger.textContent = config.linkText;
    }

    if (config.modalId) {
      trigger.setAttribute('on:click', `#${config.modalId}/showDialog`);
    }
  }

  function syncConfig(config) {
    const modalId = config.modalId || '';
    const placed = new Set();

    findOptionAnchors(config).forEach((anchor) => {
      const sibling = resolveRowSibling(anchor);
      const next = sibling.nextElementSibling;
      const row = next?.matches(ROW_SELECTOR) ? next : createRow();

      if (row.previousElementSibling !== sibling) {
        sibling.after(row);
      }

      applyConfig(row, config);
      placed.add(row);
    });

    document.querySelectorAll(ROW_SELECTOR).forEach((row) => {
      if (row.dataset.modalId === modalId && !placed.has(row)) row.remove();
    });
  }

  function syncAll(configs) {
    if (!configs.length || !hasWizardDOM()) return;

    markWizardActive();
    configs.forEach(syncConfig);
  }

  function initSizeGuideWizard() {
    const configs = readConfigs();
    if (!configs.length) return;

    syncAll(configs);

    const root = document.querySelector('.product-information') || document.body;
    let rafId = null;

    const scheduleSync = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        syncAll(configs);
      });
    };

    const observer = new MutationObserver(scheduleSync);
    observer.observe(root, { childList: true, subtree: true });

    document.addEventListener('variant:update', scheduleSync, true);
    document.addEventListener('variant:selected', scheduleSync, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideWizard);
  } else {
    initSizeGuideWizard();
  }
})();
